import { Injectable } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { IValidationProblemDetails } from '../models/problem-details.model';
import { ProblemDetails } from './api-client';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  asProblemDetails(error: unknown): ProblemDetails | undefined {
    return this.isProblemDetails(error) ? error : undefined;
  }

  isProblemDetails(error: unknown): error is ProblemDetails {
    return (
      !!error &&
      typeof error === 'object' &&
      ('type' satisfies keyof ProblemDetails) in error &&
      ('title' satisfies keyof ProblemDetails) in error &&
      ('status' satisfies keyof ProblemDetails) in error &&
      'errors' in error
    );
  }

  getErrorCode(response: ProblemDetails): string | undefined {
    if (this.isValidationError(response)) {
      return Object.keys(response.errors)[0];
    }

    return undefined;
  }

  getErrorMessage(response: ProblemDetails): string {
    if (this.isValidationError(response)) {
      return response.errors[Object.keys(response.errors)[0]][0];
    }

    return response.title ?? translate('i18n.Common.Error.UnknownFailure');
  }

  private isValidationError(
    response: ProblemDetails,
  ): response is IValidationProblemDetails {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errors = (response as IValidationProblemDetails)?.errors;
    return (
      errors !== undefined &&
      Object.values(errors).length > 0 &&
      errors[Object.keys(errors)[0]].length > 0
    );
  }
}
